'use client';
import { rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const gradientOf = (color)=>`linear-gradient(90deg, transparent, ${color}, transparent)`;
const accentColor = (theme, active)=>{
    const shade = theme.invariants.neutral[active ? 40 : 30];
    return theme.mode === 'day' ? shade : theme.fn.rgba(shade, 0.033);
};
function styles(theme) {
    return _extends({
        /* FIX Разное поведение браузера при вычислении ширины для `a` и для `button` */ display: 'inline-block',
        width: '100%',
        boxSizing: 'border-box'
    }, theme.fn.transition(), {
        cursor: 'pointer',
        padding: rem('16 24'),
        borderRadius: theme.fn.borderRadius('4r'),
        [theme.fn.up('md1')]: {
            padding: rem('16 40')
        },
        '&[data-hovered=true]': {
            background: gradientOf(accentColor(theme))
        },
        '&:active': {
            background: gradientOf(accentColor(theme, true))
        }
    }, theme.fn.focusRing({
        visible: true,
        color: theme.palette.primary.mid
    }));
}

export { styles as default };
//# sourceMappingURL=SearchItemButton.styles.js.map
